import { Pipe, PipeTransform } from '@angular/core';

import { chronopostTrackingUrl } from '../utils/ChronopostTrackingUrl';

@Pipe({
  name: 'chronopostTrackingUrl'
})
export class ChronopostTrackingUrlPipe implements PipeTransform {

  transform(ref: string): string {
    return chronopostTrackingUrl(ref);
  }

}
